import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export function getAudioMessageApi() {
  return axios.get(`${BASE_URL}/getAudioMessage`).then(({ data }) => data);
}
